module.exports = __webpack_public_path__ + "static/media/tire_car_vector.eb34a212.svg";